<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side
        span.key-name 権限（メッセージ送信の下書きと履歴）
        span.validation-label 必須

    .register-value.show-message-radios
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          name="show-message"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="権限（メッセージ送信の下書きと履歴）")
        span.register-radio-text 全て閲覧可
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" name="show-message" type="radio" :value="1")
        span.register-radio-text 他人のは閲覧不可

    .error-messages(v-for="error in errors.collect('show-message')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputShowMessage extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  private value!: number;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.show-message-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}
// ラジオボタンが2つしかないのでラップされることはありえないのでマージン調整
.register-radio-label {
  margin: 0 8px 0 0 !important;
}
</style>
